import { useEffect, useState } from "react";
import useReveal from "@/hooks/useReveal";

const WA_LINK =
  "https://wa.me/34611474969?text=Hola%20Nico%2C%20vengo%20de%20la%20web.%20Quiero%20montar%20una%20marca%20de%20___%20y%20mi%20situaci%C3%B3n%20ahora%20es%20___";

const IG_LINK = "https://instagram.com/nicocalachi";

const MARQUEE_ITEMS = [
  "Shopify",
  "Branding",
  "Diseño de producto",
  "Proveedor",
  "Finanzas",
  "7 días",
  "849€",
  "Todo incluido",
];

const MANIFESTO = [
  {
    title: "No soy un gurú.",
    body: "No tengo un método mágico ni un sistema con nombre en inglés.",
  },
  {
    title: "Esto no es un curso.",
    body: "No vas a ver vídeos prometiéndote que mañana cambia todo.",
  },
  {
    title: "No es una comunidad.",
    body: "Ni un Discord con 400 personas preguntando lo mismo.",
  },
  {
    title: "No son cuatro PDFs.",
    body: "Eso te lo sacas tú solo con ChatGPT en una tarde.",
  },
  {
    title: "No te prometo que vendas.",
    body: "Eso ya depende de ti a partir del día 8.",
  },
];

const DELIVERABLES = [
  {
    n: "01",
    t: "Web de Shopify completa",
    d: "Tu tienda con pasarela de pago, envíos, pixels y newsletter. Lista para vender.",
    v: "1.200€",
  },
  {
    n: "02",
    t: "Logo y brand book",
    d: "Concepto, tipografía, paleta, usos. Algo que puedes enseñar sin que te dé vergüenza.",
    v: "800€",
  },
  {
    n: "03",
    t: "Primer diseño de producto",
    d: "Tu primera prenda diseñada por uno de mis diseñadores de confianza. Lista para producir.",
    v: "450€",
  },
  {
    n: "04",
    t: "Acceso a proveedor o fábrica",
    d: "Dos opciones según cómo quieras arrancar. Elegimos juntos en el día 4:",
    v: "Incalculable",
    options: [
      {
        tag: "Opción A",
        text: "Acceso a mi proveedor bajo demanda. Produces sin invertir en stock.",
      },
      {
        tag: "Opción B",
        text: "Prendas complejas por unidades (no blanks). Acceso a mi fábrica — yo soy tu proveedor, tú trabajas en la misma fábrica que yo.",
      },
    ],
  },
  {
    n: "05",
    t: "Excel de finanzas",
    d: "Qué entra, qué sale, cuánto te queda y cuánto debes.",
    v: "250€",
  },
  {
    n: "06",
    t: "Acceso a mí, de por vida",
    d: "No soy tu socio ni voy a hacer más trabajo del que está en esta web. Pero cuando te estanques con algo, estoy. Una duda, una respuesta.",
    v: "1.400€",
  },
];

const TESTIMONIALS = [
  {
    name: "Marcos R.",
    meta: "Madrid · Streetwear",
    quote:
      "Simplemente la web que me ha hecho en Shopify ya vale más de 1.000 €, tiene todo lo que necesito. 10/10.",
  },
  {
    name: "Paula S.",
    meta: "Barcelona · Loungewear",
    quote:
      "Lo que más valoré no fue la web. Fue que me dijera las cosas claras. Me ahorró meter 1.500 € en stock que no iba a vender.",
  },
  {
    name: "Álvaro M.",
    meta: "Valencia · Técnica",
    quote:
      "Llevaba dos años intentándolo por mi cuenta. Nico en una semana montó lo que yo no había conseguido. Su fábrica me ahorró meses.",
  },
];

const TIMELINE = [
  { n: "01", t: "Conversación", d: "Qué quieres vender, a quién, y por qué." },
  { n: "02", t: "Concepto", d: "Nombre, dirección visual, universo de marca." },
  { n: "03", t: "Identidad", d: "Logo y brand book." },
  { n: "04", t: "Producto", d: "Primer diseño + proveedor." },
  { n: "05", t: "Shopify", d: "Montaje de la tienda." },
  { n: "06", t: "Integraciones", d: "Pagos, envíos, pixels." },
  { n: "07", t: "Entrega", d: "Las llaves son tuyas." },
];

const REQUIREMENTS = [
  {
    n: "01",
    t: "Una idea de qué quieres vender.",
    d: "No hace falta que esté pulida. Hace falta que exista.",
  },
  {
    n: "02",
    t: "849€.",
    d: "Por adelantado, antes del día 1.",
  },
  {
    n: "03",
    t: "Estar disponible 7 días.",
    d: "No 24h, pero sí para contestar cuando pregunte.",
  },
];

const COSTS = [
  {
    t: "Shopify, a partir del mes 4",
    d: "3 primeros meses a 1€. Después ~32€/mes.",
  },
  {
    t: "El dominio",
    d: "~14€/año. A tu nombre, no al mío.",
  },
  {
    t: "Tu primer pedido",
    d: "Desde 30€ una muestra. El día 4 tienes números reales.",
  },
];

const FAQS = [
  {
    q: "¿Por qué 849€ y no 2.000€ como otros?",
    a: "Porque no te estoy vendiendo un método ni una promesa de facturación. Te vendo 7 días de mi tiempo y 6 entregables concretos.",
  },
  {
    q: "¿Y si mi marca no vende nada después?",
    a: "Pasa. Yo te entrego la marca montada, no clientes. Vender depende de lo que hagas tú a partir del día 8.",
  },
  {
    q: "¿Puedo pagar a plazos?",
    a: "No. Son 849€ por adelantado. Si esa cifra te bloquea, probablemente no es el momento.",
  },
  {
    q: "¿Qué pasa si no me gusta el logo?",
    a: "Iteramos dentro de los 7 días. No es un tómalo o déjalo.",
  },
  {
    q: "¿El proveedor es de verdad bueno?",
    a: "Es el mío. Le compro yo. Si fuera malo, mi marca tampoco funcionaría.",
  },
  {
    q: "¿Sirve si no sé de moda?",
    a: "Sirve si tienes una idea de qué vender y a quién. Si vienes a cero absoluto, te lo digo por WhatsApp antes de cobrarte.",
  },
  {
    q: "¿Por qué WhatsApp y no un formulario?",
    a: "Porque si vamos a trabajar 7 días juntos, lo mínimo es que sepamos hablar por WhatsApp sin que sea raro.",
  },
];

/* ---------- Ripple CTA ---------- */
function WhatsAppCTA({ className = "", children, testId, size = "md" }) {
  const btnClass =
    size === "xl" ? "btn btn-xl" : size === "ghost" ? "btn btn-ghost" : "btn btn-primary";

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const ripple = document.createElement("span");
    const diameter = Math.max(rect.width, rect.height);
    const radius = diameter / 2;
    ripple.className = "ripple";
    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - rect.left - radius}px`;
    ripple.style.top = `${e.clientY - rect.top - radius}px`;
    e.currentTarget.appendChild(ripple);
    setTimeout(() => ripple.remove(), 700);
  };

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={`${btnClass} ${className}`}
      data-testid={testId}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}

/* ---------- Nav ---------- */
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <nav className={`nav ${scrolled ? "scrolled" : ""}`} data-testid="main-nav">
      <div className="container-x nav-inner">
        <a
          href={IG_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-handle"
          data-testid="nav-instagram-link"
        >
          @nicocalachi
        </a>
        <WhatsAppCTA testId="nav-whatsapp-btn">Escríbeme</WhatsAppCTA>
      </div>
    </nav>
  );
}

/* ---------- Marquee ---------- */
function Marquee() {
  const content = (
    <>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="marquee-item">
          {item}
          <span className="marquee-dot" />
        </span>
      ))}
    </>
  );
  return (
    <div className="marquee" data-testid="marquee-band">
      <div className="marquee-track">
        {content}
        {content}
      </div>
    </div>
  );
}

/* ---------- Hero ---------- */
function Hero() {
  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-glow hero-glow-a" aria-hidden="true" />
      <div className="hero-glow hero-glow-b" aria-hidden="true" />
      <div className="hero-glow hero-glow-c" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />
      <h1 className="h-display reveal">
        Tu propia marca de ropa,{" "}
        <em className="italic-gold">lista en 7 días.</em>
      </h1>
      <p className="hero-sub reveal">
        Yo te monto la web, el logo, el proveedor y las finanzas. Tú solo te
        encargas del marketing.
      </p>
      <div className="reveal">
        <WhatsAppCTA size="xl" testId="hero-whatsapp-btn">
          Escríbeme por WhatsApp <span aria-hidden>→</span>
        </WhatsAppCTA>
      </div>

      <div className="hero-photos" data-testid="hero-photos">
        <div className="hero-photo has-image hero-photo-contain">
          <img src="/img/hero-ronaldo-ig.jpg" alt="Post de Chevi con Cristiano Jr." loading="lazy" />
        </div>
        <div className="hero-photo has-image hero-photo-contain">
          <img src="/img/hero-stock.jpg" alt="Stock de Chevi en almacén" loading="lazy" />
        </div>
        <div className="hero-photo has-image hero-photo-contain">
          <img src="/img/hero-shopify-notifs.jpg" alt="Notificaciones de pedidos Shopify de Chevi" loading="lazy" />
        </div>
      </div>

      <div className="stats reveal stagger">
        <div className="stat-pill">
          <span className="stat-num">7 cifras</span>
          <span className="stat-label">Facturadas</span>
        </div>
        <div className="stat-pill">
          <span className="stat-num">+40</span>
          <span className="stat-label">Tiendas montadas</span>
        </div>
        <div className="stat-pill">
          <span className="stat-num">5 años</span>
          <span className="stat-label">En moda</span>
        </div>
      </div>
    </section>
  );
}

/* ---------- Manifesto ---------- */
function Manifesto() {
  return (
    <section className="section section-soft" data-testid="manifesto-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Antes de nada</span>
          <h2 className="h-display reveal">
            Esto es lo que <em className="italic-gold">no soy.</em>
          </h2>
        </div>
        <div className="manifesto">
          {MANIFESTO.map((item, i) => (
            <div
              key={i}
              className="manifesto-item reveal-left"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="manifesto-num">{String(i + 1).padStart(2, "0")}</div>
              <div className="manifesto-body">
                <strong>{item.title}</strong>
                <p>{item.body}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="manifesto-close reveal">
          Esto es un <span className="italic-gold">servicio.</span> Yo, 7 días,
          montándote todo lo que necesitas para que el lunes puedas empezar a
          vender. Punto.
        </div>
      </div>
    </section>
  );
}

/* ---------- About ---------- */
function About() {
  return (
    <section className="section" data-testid="about-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Sobre mí</span>
          <h2 className="h-display reveal">
            ¿Por qué <em className="italic-gold">confiar en mí?</em>
          </h2>
        </div>
        <div className="about-photos reveal stagger">
          <div className="about-photo has-image">
            <img src="/img/nicolas.jpg" alt="Nicolás Del Álamo" loading="lazy" />
          </div>
          <div className="about-photo has-image about-photo-shopify">
            <img src="/img/shopify-pedidos.jpg" alt="Pedidos reales en Shopify" loading="lazy" />
          </div>
        </div>
        <div className="about-text reveal">
          <p>
            Me llamo Nicolás, tengo 20 años y llevo cinco en esto. Empecé con 15
            con mi marca Chevi. Facturé 6 cifras antes de los 19. Pasé por
            cuatro socios. La cagué en casi todo lo que se puede cagar:
            proveedores, stock, socios. Ahora estoy reconstruyendo Chevi desde
            cero, en público.
          </p>
          <p>
            He montado más de 40 tiendas en Shopify. Sé qué integraciones hacen
            falta y cuáles sobran. Sé qué proveedor te va a contestar y cuál te
            va a desaparecer. Sé qué errores te van a costar 3.000€ porque me
            costaron a mí primero.
          </p>
        </div>
        <div className="about-closer reveal">
          No te vendo el éxito de Chevi. Te vendo lo que aprendí{" "}
          <em className="italic-gold">pagándolo.</em>
        </div>
      </div>
    </section>
  );
}

/* ---------- Deliverables ---------- */
function Deliverables() {
  return (
    <section className="section section-soft" data-testid="deliverables-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Entregables</span>
          <h2 className="h-display reveal">
            Lo que tienes en la mano{" "}
            <em className="italic-gold">el día 7.</em>
          </h2>
        </div>
        <div className="deliv-grid stagger reveal">
          {DELIVERABLES.map((d) => (
            <div key={d.n} className="deliv-card" data-testid={`deliverable-${d.n}`}>
              <div className="deliv-num">{d.n}</div>
              {d.v && <div className="deliv-value">{d.v}</div>}
              <div className="deliv-title">{d.t}</div>
              <p className="deliv-desc">{d.d}</p>
              {d.options && (
                <ul className="deliv-options">
                  {d.options.map((opt, i) => (
                    <li key={i} className="deliv-option">
                      <span className="deliv-option-tag">{opt.tag}</span>
                      <span className="deliv-option-text">{opt.text}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
        <div className="bonus-pill reveal">
          <strong>Extra incluido:</strong>{" "}
          entras con mi enlace de partner de Shopify. Los 3 primeros meses te
          cuestan 1€/mes.
        </div>
     <div className="price-block reveal" data-testid="price-block">
          <div className="price-num">
            <span style={{textDecoration: "line-through", opacity: 0.4, fontSize: "0.5em", marginRight: "24px"}}>4.100€</span>
            <em>849€.</em>
          </div>
        </div>
      </div>
    </section>
  );
}
/* ---------- Timeline ---------- */
function Timeline() {
  return (
    <section className="section" data-testid="timeline-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Proceso</span>
          <h2 className="h-display reveal">
            Cómo van <em className="italic-gold">los 7 días.</em>
          </h2>
        </div>
        <div className="timeline stagger reveal">
          {TIMELINE.map((t) => (
            <div key={t.n} className="timeline-card" data-testid={`timeline-day-${t.n}`}>
              <div className="timeline-day">Día {t.n}</div>
              <div className="timeline-num">{t.n}</div>
              <div className="timeline-title">{t.t}</div>
              <p className="timeline-desc">{t.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------- Testimonials ---------- */
function Testimonials() {
  return (
    <section className="section" data-testid="testimonials-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Testimonios</span>
          <h2 className="h-display reveal">
            Lo que dicen{" "}
            <em className="italic-gold">los que ya pasaron por aquí.</em>
          </h2>
        </div>
        <div className="testi-grid stagger reveal">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              className="testi-card"
              data-testid={`testimonial-${i}`}
            >
              <span className="testi-quote" aria-hidden="true">“</span>
              <blockquote className="testi-text">{t.quote}</blockquote>
              <figcaption className="testi-foot">
                <span className="testi-avatar" aria-hidden="true">
                  {t.name.charAt(0)}
                </span>
                <span className="testi-meta">
                  <span className="testi-name">{t.name}</span>
                  <span className="testi-sub">{t.meta}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------- Featured Collaboration (Kappah) ---------- */
function Collab() {
  return (
    <section className="section section-soft" data-testid="collab-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Colaboraciones</span>
          <h2 className="h-display reveal">
            Aparte de mi marca y mis clientes, trabajo con{" "}
            <em className="italic-gold">otros nombres.</em>
          </h2>
        </div>
        <div className="collab-card reveal">
          <div className="collab-photos stagger reveal">
            <div className="collab-photo collab-photo-1 has-image">
              <img src="/img/kappah-1.jpg" alt="Kappah con su sudadera Kappah" loading="lazy" />
              <span className="collab-photo-label">Kappah · Lanzamiento</span>
            </div>
            <div className="collab-photo collab-photo-2 has-image">
              <img src="/img/kappah-2.jpg" alt="Clientes reales llevando Kappah en Madrid" loading="lazy" />
              <span className="collab-photo-label">Kappah · En la calle</span>
            </div>
          </div>
          <div className="collab-body">
            <a
              href="https://instagram.com/kappah"
              target="_blank"
              rel="noopener noreferrer"
              className="collab-handle"
              data-testid="collab-kappah-link"
            >
              @kappah
            </a>
            <p className="collab-lead">
              Cuando{" "}
              <a
                href="https://instagram.com/kappah"
                target="_blank"
                rel="noopener noreferrer"
                className="collab-inline-link"
              >
                @kappah
              </a>{" "}
              lanzó su marca de ropa, estaba yo detrás del montaje.
            </p>
            <div className="collab-stat">
              <span className="collab-stat-num">
                5<em>+</em> cifras
              </span>
              <span className="collab-stat-label">
                facturadas en cuestión de días
              </span>
            </div>
            <p className="collab-note">
              No es magia. Es tener la infraestructura lista el día del drop y
              un público que ya estaba esperando.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ---------- Requirements ---------- */
function Requirements() {
  return (
    <section className="section" data-testid="requirements-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Requisitos</span>
          <h2 className="h-display reveal">
            Lo que necesito <em className="italic-gold">de ti.</em>
          </h2>
        </div>
        <div className="req-grid stagger reveal">
          {REQUIREMENTS.map((r) => (
            <div key={r.n} className="req-card" data-testid={`req-${r.n}`}>
              <div className="req-num">{r.n}</div>
              <div className="req-title">{r.t}</div>
              <p className="req-desc">{r.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------- Costs ---------- */
function Costs() {
  return (
    <section className="section section-soft" data-testid="costs-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">Costes extra</span>
          <h2 className="h-display reveal">
            Lo que cuesta{" "}
            <em className="italic-gold">aparte de los 849€.</em>
          </h2>
          <p className="costs-sub reveal">
            Te lo cuento ahora y no en el día 7, porque si no, no es honesto.
          </p>
        </div>
        <div className="costs-grid stagger reveal">
          {COSTS.map((c, i) => (
            <div key={i} className="cost-card" data-testid={`cost-${i}`}>
              <div className="cost-title">{c.t}</div>
              <p className="cost-desc">{c.d}</p>
            </div>
          ))}
        </div>
        <div className="cost-warn reveal" data-testid="cost-warning">
          Si tu presupuesto total es solo los 849€ y no tienes nada más detrás,
          frena. Vuelve cuando tengas al menos otros 200-300€ de margen.
        </div>
      </div>
    </section>
  );
}

/* ---------- FAQ ---------- */
function FAQ() {
  const [openIdx, setOpenIdx] = useState(-1);
  return (
    <section className="section" data-testid="faq-section">
      <div className="container-x">
        <div className="sh-head">
          <span className="label-pill reveal">FAQ</span>
          <h2 className="h-display reveal">
            Preguntas que ya sé{" "}
            <em className="italic-gold">que tienes.</em>
          </h2>
        </div>
        <div className="faq-wrap reveal">
          {FAQS.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`faq-item ${isOpen ? "open" : ""}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  className="faq-trigger"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  <span className="faq-icon" aria-hidden="true" />
                </button>
                <div className="faq-content">
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ---------- Final CTA + Footer ---------- */
function FinalCTA() {
  return (
    <section className="section final-cta" data-testid="final-cta-section">
      <div className="container-x">
        <div className="sh-head">
          <h2 className="h-display reveal">
            Ya sabes si <em className="italic-gold">te encaja.</em>
          </h2>
        </div>
        <p className="reveal">
          Escríbeme. No hay llamada, no hay embudo. Me cuentas qué quieres
          montar y empezamos.
        </p>
        <div className="reveal">
          <WhatsAppCTA size="xl" testId="final-whatsapp-btn">
            Quiero mi marca de ropa <span aria-hidden>→</span>
          </WhatsAppCTA>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <a
        href={IG_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-ig"
        data-testid="footer-instagram-link"
      >
        @nicocalachi
      </a>
      <div className="footer-note">
        © 2026 Nicolás Del Álamo · montotumarca.com
      </div>
    </footer>
  );
}

/* ---------- Main ---------- */
export default function Landing() {
  useReveal();
  return (
    <div data-testid="landing-root">
      <Navbar />
      <Marquee />
      <Hero />
      <Manifesto />
      <About />
      <Deliverables />
      <Timeline />
      <Collab />
      <Testimonials />
      <Requirements />
      <Costs />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
